import { render, staticRenderFns } from "./TransactionInsightPopup.vue?vue&type=template&id=2b69b9ee"
import script from "./TransactionInsightPopup.vue?vue&type=script&lang=js"
export * from "./TransactionInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./TransactionInsightPopup.vue?vue&type=style&index=0&id=2b69b9ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports